import { render, staticRenderFns } from "./TableOriginal.vue?vue&type=template&id=8cb94e7a&"
import script from "./TableOriginal.vue?vue&type=script&lang=js&"
export * from "./TableOriginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports